import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + "/grader/vending";
  // return "http://192.168.1.18:3301/grader/vending"
};

export const vendingURL = () => {
  return APIHost() + "/vending/grader";
  // return "http://192.168.1.18:3301/grader/vending"
};

export const loadVendingCount = data => {
  const url = `${baseURL()}/count`;
  return axios.post(url, data);
};

export const loadVendingLocationList = data => {
  const url = `${baseURL()}/location/list`;
  return axios.post(url, data);
};

export const loadVendingList = data => {
  const url = `${baseURL()}/list`;
  return axios.post(url, data);
};

export const loadVendingDetail = (id, data) => {
  const url = `${baseURL()}/detail/${id}`;
  return axios.post(url, data);
};

export const createVending = (data) => {
  const url = `${baseURL()}/create`;
  return axios.post(url, data);
};

export const updateVending = (id, data) => {
  const url = `${baseURL()}/update/${id}`;
  return axios.post(url, data);
};

export const resetPwd = (id, data) => {
  const url = `${baseURL()}/resetPwd/${id}`;
  return axios.post(url, data);
};

export const delVending = (id, data) => {
  const url = `${baseURL()}/remove/${id}`;
  return axios.post(url, data);
};


export const rebootVending = (id, data) => {
  const url = `${vendingURL()}/reboot/${id}`;
  return axios.post(url, data);
};

export const stopVending = (id, data) => {
  const url = `${vendingURL()}/stop/${id}`;
  return axios.post(url, data);
};


export const startVending = (id, data) => {
  const url = `${vendingURL()}/start/${id}`;
  return axios.post(url, data);
};


export const testConnection = (id, data) => {
  const url = `${vendingURL()}/testConnection/${id}`;
  return axios.post(url, data);
};

export const setPlacement = (id, data) => {
  const url = `${baseURL()}/placement/${id}`;
  return axios.post(url, data);
};

export const loadVendingCouncilList = data => {
  const url = `${baseURL()}/council/list`;
  return axios.post(url, data);
};
